import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useIsMobile } from '../../style/constants';
import { Container } from '../../VuexyDesign/atoms/_index';
import HowToUseHeroSection from '../../components/HowItWorks/HowToUseHeroSection';
import FAQ from '../../components/HowItWorks/FAQ';
import { howToUse } from '../../components/HowItWorks/AccordionContent';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import {
  HowItWorksRowDesktop,
  HowItWorksRowMobile,
} from '../../VuexyDesign/organisms/_index';
import { VirpPageContext } from '../_app';

const howTos = [
  {
    key: 1,
    headerTitle: 'howItWorks:howToUse.headerTitle.setupProfile',
    title: 'howItWorks:howToUse.completeProfile',
    subtitle: 'howItWorks:howToUseDescriptions.completeProfile',
    media: 'https://www.youtube-nocookie.com/embed/RK3fqQ0O1aM',
    leftColumn: '7',
    rightColumn: '5',
    picture: false,
    videoLeft: false,
  },
  {
    key: 2,
    headerTitle: 'howItWorks:howToUse.headerTitle.getStarted',
    title: 'howItWorks:howToUse.uploadTracks',
    subtitle: 'howItWorks:howToUseDescriptions.uploadYourTracks',
    media: 'https://www.youtube-nocookie.com/embed/7YnjNqnTszc',
    leftColumn: '6',
    rightColumn: '5',
    picture: false,
    videoLeft: true,
  },
  {
    key: 3,
    headerTitle: 'howItWorks:howToUse.headerTitle.feedback',
    title: 'howItWorks:howToUse.getFeedbackFromOthers',
    subtitle: 'howItWorks:howToUseDescriptions.getFeedback',
    media: 'https://www.youtube-nocookie.com/embed/A75oRoT9vBg',
    leftColumn: '7',
    rightColumn: '5',
    picture: false,
    videoLeft: false,
  },
  {
    key: 4,
    headerTitle: 'howItWorks:howToUse.headerTitle.connectWithLabels',
    title: 'howItWorks:howToUse.joinContests',
    subtitle: 'howItWorks:howToUseDescriptions.joinContests',
    media: 'https://www.youtube-nocookie.com/embed/XOW-oWRryN8',
    leftColumn: '6',
    rightColumn: '5',
    picture: false,
    videoLeft: true,
  },
  {
    key: 5,
    headerTitle: 'howItWorks:howToUse.headerTitle.getDiscovered',
    title: 'howItWorks:howToUse.getDiscovered',
    subtitle: 'howItWorks:howToUseDescriptions.getDiscovered',
    media: 'https://www.youtube-nocookie.com/embed/Gfo7qnm4HlI',
    leftColumn: '7',
    rightColumn: '5',
    picture: false,
    videoLeft: false,
  },
];

const Index = () => {
  const { t } = useTranslation('howItWorks');
  const isMobile = useIsMobile();

  return (
    <div className="d-flex w-100 justify-content-center align-items-center flex-column">
      <BrowserPageTitle>{t('howItWorks:howToUse.howToUse')}</BrowserPageTitle>
      <Container
        fluid
        className="d-flex align-items-center position-relative px-0"
      >
        <HowToUseHeroSection />
      </Container>
      {howTos.map((howTo) =>
        isMobile ? (
          <HowItWorksRowMobile
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            picture={howTo.picture}
          />
        ) : (
          <HowItWorksRowDesktop
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            leftColumn={howTo.leftColumn}
            rightColumn={howTo.rightColumn}
            videoLeft={howTo.videoLeft}
            picture={howTo.picture}
          />
        ),
      )}

      <FAQ page={howToUse} />
    </div>
  );
};

Index.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/how-it-works/how-to-use',
  });
  return { ...getTranslations };
};

export default Index;
